import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { ILeadContract } from '@clickersphere/core/entities/ILeadContract';
import LeadContractService from '@clickersphere/core/services/LeadContractService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const LEAD_CONTRACTS_QUERY_KEY = 'lead-contracts';

export type LeadContractQueryData = WithQueryStatus<ILeadContract>;

export function useLeadContracts(leadId: string) {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: leadContracts,
    isSuccess: isLeadContractsSuccess,
    isFetching: isLeadContractsFetching,
    isLoading: isLeadContractsLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId && !!leadId,
    queryKey: buildQueryKey([LEAD_CONTRACTS_QUERY_KEY, leadId]),
    queryFn: async () => {
      const result = await LeadContractService.getByLead(leadId);
      return result as LeadContractQueryData[];
    },
    select: (data) =>
      [...data].sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      ),
  });

  return {
    leadContracts: leadContracts ?? [],
    isLeadContractsSuccess,
    isLeadContractsFetching,
    isLeadContractsLoading,
  };
}
